import { useState, useCallback, useMemo } from 'react';
import { scrollToTop } from '../libs/scrollUtils';

export const usePages = <T,>(items: T[], paginatePer: number) => {
  const [page, setPage] = useState(1);

  const handlePageChange = useCallback(
    (newPage: number) => {
      if (newPage === page) return;
      scrollToTop();
      setPage(newPage);
    },
    [page]
  );

  const shouldShowPagination = useMemo(
    () => items.length > paginatePer,
    [items.length, paginatePer]
  );

  const paginatedItems = useMemo(() => {
    const start = (page - 1) * paginatePer;
    const end = start + paginatePer;
    return items.slice(start, end);
  }, [items, page, paginatePer]);

  return {
    page,
    setPage,
    handlePageChange,
    shouldShowPagination,
    paginatedItems,
  };
};
